const theme = import.meta.env.VITE_THEME

export const useIsGoTo = () => {
    return {isGoTo: theme === 'goto', name:theme};

}
